import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import { getPlicOauthUrl } from './helpers';

const propTypes = {
  children: PropTypes.node,
  state: PropTypes.string,
};

const PLICBooksLogin = ({ children, state, ...props }) => {
  return (
    <Button {...props} href={getPlicOauthUrl(state)}>
      {children}
    </Button>
  );
};

PLICBooksLogin.propTypes = propTypes;

export default PLICBooksLogin;
